import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, ORM } from 'utility-ts-orm';
import { SurveyQuestion } from '../builders/survey_question_builder';
import { ISurveyQuestionTypeFormDef, SurveyQuestionTypeStrategy } from '../strategies/survey_question_type_strategy';

interface ISurveyQuestionQueryResult {
  question: SurveyQuestion;
  questionTypeDef: ISurveyQuestionTypeFormDef;
}

export class SurveyQuestionQuery implements IQuery {
  private _result: ISurveyQuestionQueryResult;

  constructor(private ngSurveyQuestionDatastore: IDatasource<SurveyQuestion>) {
    ORM.registerQuery(this, this.ngSurveyQuestionDatastore);
  }

  run(): this {
    this._result = {} as ISurveyQuestionQueryResult;
    const question = _4.first(this.ngSurveyQuestionDatastore.values());
    const questionType = _4.get(question, 'question.question_type', '');

    if (!_4.isEmpty(question)) {
      this._result = {
        question,
        questionTypeDef: SurveyQuestionTypeStrategy.getByKey(questionType).buildFormInput(question)
      };
    }

    return this;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/queries/survey_question_query.ts